import React from "react";

const SvgOneguardLogomarkColor = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 96.06 96.06" {...props}>
      <defs>
        <style>{".oneguard-logomark-color_svg__cls-1{fill:#585959}"}</style>
      </defs>
      <g id="oneguard-logomark-color_svg__full-rgb">
        <path
          id="oneguard-logomark-color_svg__fullLogo"
          className="oneguard-logomark-color_svg__cls-1"
          d="M36.67 41.3v-8.24l15.51-11.6a25.76 25.76 0 00-2.93-.17 26.57 26.57 0 100 53.13l.13-33.12z"
        />
        <path
          id="oneguard-logomark-color_svg__fullLogo-2"
          data-name="fullLogo"
          d="M82.29 13.77Q68.52 0 48 0T13.77 13.77Q0 27.54 0 48t13.77 34.26Q27.54 96.06 48 96.06t34.29-13.77Q96.06 68.52 96.06 48T82.29 13.77zM48.54 78.69a30.84 30.84 0 1130.84-30.84 30.84 30.84 0 01-30.84 30.84z"
          fill="#94292b"
        />
        <path
          id="oneguard-logomark-color_svg__fullLogo-3"
          data-name="fullLogo"
          className="oneguard-logomark-color_svg__cls-1"
          d="M85.26 86.82h-1.54v-.66h3.77v.66H86V91h-.69zm3.29-.66h.73L91 88.79l1.7-2.63h.71V91h-.67v-3.72L91 89.88h-.09l-1.7-2.6V91h-.68z"
        />
      </g>
    </svg>
  );
};

export default SvgOneguardLogomarkColor;
